import { MissionToStaffSalaryFilter } from '../../lib/types/models/mission-tracking/mission-tracking'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type SalaryTotal = {
  total: number
}

export async function getMissionTrackingTotalSalariesWithPas(
  filters: MissionToStaffSalaryFilter
): Promise<SalaryTotal> {
  return restApiClient
    .url(
      encodeNestedObject(API.missionTrackings.getMissionTrackingsSalaries.url, {
        ...filters,
        totalSalaryWithPas: true
      })
    )
    .get()
}

export async function getMissionTrackingTotalSalariesWithoutPas(
  filters: MissionToStaffSalaryFilter
): Promise<SalaryTotal> {
  return restApiClient
    .url(
      encodeNestedObject(API.missionTrackings.getMissionTrackingsSalaries.url, {
        ...filters,
        totalSalaryWithoutPas: true
      })
    )
    .get()
}
